import { isEdlEnabled } from '@/components/TopBar/edlAccess'
import { investorBeforeEnter } from '@/router/rules/investorBeforeEnter'
import { realEstatesRoute } from '@/router/routes/contants'

// Garde des écrans « État des lieux » (rollout progressif). FAIL-CLOSED : un compte hors
// liste blanche (edlAccess) est redirigé, même s'il tape l'URL en direct. Pour la liste
// blanche, on applique ensuite le garde investisseur habituel (onboarding si aucun bien).
//
// IMPORTANT (Vue Router 4) : NE PAS déclarer le paramètre `next`. Dès qu'un garde a une
// arité >= 3, Vue Router attend un appel explicite à next() et n'utilise PAS la valeur de
// retour -> la navigation reste bloquée à l'infini (l'écran ne se charge jamais). En arité 2,
// la valeur retournée (true | chemin de redirection) est appliquée automatiquement, comme
// investorBeforeEnter (arité 0). Ne jamais réintroduire `next` ici.
export const edlBeforeEnter = async (to, from) => {
  if (!isEdlEnabled()) {
    return realEstatesRoute.path
  }

  return investorBeforeEnter(to, from)
}
